import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RouteState, State } from '../reducers';

import { LoadingState, getError } from 'app/utils/callstate';
import { CompanyState } from '../company.types';

export const getRouteState = createFeatureSelector<State, RouteState>('company');

export const selectCompanyState = createSelector(
    getRouteState,
    ({ company }): CompanyState => company
);

export const selectCompany = createSelector(
    selectCompanyState,
    companyState => companyState.company
);

export const selectCompanyLoading = createSelector(
    selectCompanyState,
    companyState => companyState.callState === LoadingState.Loading
);

export const selectCompanyLoaded = createSelector(
    selectCompanyState,
    companyState => companyState.callState === LoadingState.Loaded
);

export const selectCompanyError = createSelector(
    selectCompanyState,
    companyState => getError(companyState.callState)
);
